import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {ViewAnswerResponse} from "features/model/types/test/test-view-answer-id/testViewAnswerIdShema";
import {setTestViewAnswerId} from "features/model/slice/test/test-view-answer-id/testViewAnswerIdSlice";
import {setNotFoundError} from "features/model/slice/error/errorSlice";

interface ITestViewAnswerId {
    testId: string;
    userId: string;
}

export const testViewAnswerId = createAsyncThunk(
    "test/viewAnswerId",
    async ({testId, userId}: ITestViewAnswerId, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.get<ViewAnswerResponse>(`/api/tests/${testId}/view-answer/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },

            });

            if (response.data.success) {
                thunkAPI.dispatch(setTestViewAnswerId(response.data));
            }
            if (!response.data.success) {
                throw new Error("Response data is empty");
            }
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
